/* Formed: accessible compact bundle controls and the paid-in-full STOQ preorder. */
(() => {
  const planId = '15847784638';
  const rootSelector = '#ab-dynamic-pricing-bundle-product-page';
  const planSelector = '#ab-bundle-selling-plan-dropdown';
  const valueSetter = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'value').set;
  const pendingPlans = new WeakSet();
  let scheduled = false;

  function choose(select, value) {
    valueSetter.call(select, value);
    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function preorder(select) {
    if (!Array.from(select.options).some(option => option.value === planId)) return false;
    Array.from(select.options).forEach(option => {
      if (option.value !== planId) { option.disabled = true; option.hidden = true; }
    });
    select.required = true;
    select.setCustomValidity('');
    if (select.value !== planId && !pendingPlans.has(select)) {
      pendingPlans.add(select);
      // Wait for the app to finish mounting its controlled select before notifying it.
      requestAnimationFrame(() => requestAnimationFrame(() => {
        pendingPlans.delete(select);
        if (!select.isConnected) return;
        choose(select, planId);
        select.closest(rootSelector)?.setAttribute('data-formed-auto-preorder', 'true');
      }));
    } else if (select.value === planId) {
      select.closest(rootSelector)?.setAttribute('data-formed-auto-preorder', 'true');
    }
    return true;
  }
  function accordion(root) {
    const block = root.closest('.shopify-app-block');
    if (!block || block.parentElement.matches('.formed-bundle-accordion')) return;
    const details = document.createElement('details');
    details.className = 'formed-bundle-accordion';
    const summary = document.createElement('summary');
    summary.className = 'formed-bundle-summary';
    const title = document.createElement('span');
    title.textContent = 'Choose Your Bundle';
    const hint = document.createElement('span');
    hint.className = 'formed-bundle-summary-hint';
    hint.textContent = 'Choose 2 or more. Save 15%.';
    summary.append(title, hint);
    details.append(summary);
    block.before(details);
    details.append(block);
  }

  function purchaseChoices(root) {
    const widget = document.querySelector('#appstle_subscription_widget0');
    const one = widget?.querySelector('#appstle_selling_plan_label_10');
    const subscription = widget?.querySelector('#appstle_selling_plan_label_20');
    const details = root.closest('.formed-bundle-accordion');
    if (!widget || !one || !subscription || !details) return;
    let choices = document.querySelector('.formed-purchase-choices');
    if (!choices) {
      choices = document.createElement('fieldset');
      choices.className = 'formed-purchase-choices';
      const legend = document.createElement('legend');
      legend.textContent = 'Purchase Options';
      choices.append(legend);
      [
        ['one-time', 'One-time purchase', ''],
        ['subscription', 'Subscribe & Save', 'SAVE 10%'],
        ['bundle', 'Build Your Bundle', 'SAVE 15%']
      ].forEach(([mode, title, badgeText]) => {
        const row = document.createElement('label');
        row.className = 'formed-purchase-choice';
        const input = document.createElement('input');
        input.type = 'radio'; input.name = 'formed-purchase-mode'; input.value = mode;
        input.addEventListener('change', () => {
          if (!input.checked) return;
          if (mode === 'one-time') document.querySelector('#appstle_selling_plan_label_10')?.click();
          if (mode === 'subscription') document.querySelector('#appstle_selling_plan_label_20')?.click();
          choices.dataset.mode = mode;
          scheduleRefresh();
        });
        const name = document.createElement('span');
        name.className = 'formed-purchase-choice-name'; name.textContent = title;
        row.append(input, name);
        if (badgeText) {
          const badge = document.createElement('span');
          badge.className = 'formed-purchase-badge'; badge.textContent = badgeText;
          row.append(badge);
        }
        const price = document.createElement('span');
        price.className = 'formed-purchase-choice-price'; price.dataset.mode = mode;
        row.append(price);
        choices.append(row);
      });
      choices.dataset.mode = subscription.checked ? 'subscription' : 'one-time';
      widget.before(choices);
    }
    const mode = choices.dataset.mode || 'one-time';
    const block = widget.closest('.shopify-app-block')?.parentElement;
    if (block && details.previousElementSibling !== block) block.after(details);
    details.classList.add('formed-bundle-integrated');
    details.open = mode === 'bundle';
    if (details.dataset.mode !== mode) details.dataset.mode = mode;
    if (widget.dataset.formedMode !== mode) widget.dataset.formedMode = mode;
    if (document.body.dataset.formedPurchaseMode !== mode) document.body.dataset.formedPurchaseMode = mode;
    choices.querySelectorAll('input').forEach(input => { input.checked = input.value === mode; });
    const prices = {
      'one-time': widget.querySelector('.appstle_one_time_price_wrapper .appstle_subscription_amount')?.textContent.trim() || '',
      'subscription': widget.querySelector('.appstle_subscription_amount_wrapper .appstle_subscription_amount')?.textContent.trim() || '',
      'bundle': '2+ balms'
    };
    choices.querySelectorAll('.formed-purchase-choice-price').forEach(price => {
      const value = prices[price.dataset.mode];
      if (price.textContent !== value) price.textContent = value;
    });
  }

  function sizes(card) {
    const select = card.querySelector('.ab-bundle-variant-dropdown');
    if (!select) return;
    const holder = select.parentElement;
    let group = holder.querySelector('.formed-bundle-sizes');
    const options = Array.from(select.options);
    const signature = options.map(option => option.value + ':' + option.textContent).join('|');
    if (!group || group.dataset.options !== signature) {
      group?.remove();
      group = document.createElement('div');
      group.className = 'formed-bundle-sizes';
      group.dataset.options = signature;
      group.setAttribute('role', 'group');
      const name = card.querySelector('.ab-bundle-product-title-link')?.textContent.trim() || 'balm';
      group.setAttribute('aria-label', 'Size for ' + name);
      options.forEach(option => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'formed-bundle-size';
        button.dataset.value = option.value;
        button.textContent = option.textContent.trim().replace(/\.$/, '');
        button.addEventListener('click', () => choose(select, option.value));
        group.append(button);
      });
      holder.append(group);
      select.classList.add('formed-bundle-native-size');
    }
    Array.from(group.children).forEach(button => {
      const option = options.find(item => item.value === button.dataset.value);
      const pressed = String(select.value === button.dataset.value);
      if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
      button.disabled = !option || option.disabled;
    });
    // The app renders its real quantity control once selected. Start at zero beforehand.
    const add = card.querySelector('.ab-bundle-product-add-to-bundle');
    let zero = card.querySelector('.formed-bundle-zero-quantity');
    if (!add || add.disabled) { zero?.remove(); return; }
    if (!zero) {
      zero = document.createElement('div');
      zero.className = 'formed-bundle-zero-quantity';
      const minus = document.createElement('button');
      minus.type = 'button'; minus.disabled = true; minus.textContent = '−';
      minus.setAttribute('aria-label', 'Decrease quantity');
      const count = document.createElement('span');
      count.textContent = '0'; count.setAttribute('aria-label', 'Quantity: 0');
      const plus = document.createElement('button');
      plus.type = 'button'; plus.textContent = '+';
      const name = card.querySelector('.ab-bundle-product-title-link')?.textContent.trim() || 'balm';
      plus.setAttribute('aria-label', 'Add ' + name + ' to bundle');
      plus.addEventListener('click', () => card.querySelector('.ab-bundle-product-add-to-bundle')?.click());
      zero.append(minus, count, plus);
      add.after(zero);
      add.classList.add('formed-bundle-native-add');
    }
  }
  function refresh() {
    scheduled = false;
    document.querySelectorAll(rootSelector).forEach(root => {
      accordion(root);
      purchaseChoices(root);
      root.querySelectorAll('.ab-bundle-product-card').forEach(sizes);
      const select = root.querySelector(planSelector);
      if (select) preorder(select);
      const button = root.querySelector('.ab-bundle-add-bundle-to-cart');
      const label = button?.querySelector('span');
      if (label && label.textContent !== 'Preorder') label.textContent = 'Preorder';
      if (button && button.getAttribute('aria-label') !== 'Preorder') button.setAttribute('aria-label', 'Preorder');
    });
  }
  function scheduleRefresh() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(refresh);
  }
  document.addEventListener('change', event => {
    if (event.target.closest?.(rootSelector)) scheduleRefresh();
  });
  document.addEventListener('click', event => {
    const button = event.target.closest?.(rootSelector + ' .ab-bundle-add-bundle-to-cart');
    if (!button) return;
    const select = button.closest(rootSelector).querySelector(planSelector);
    if (!select || !Array.from(select.options).some(option => option.value === planId)) {
      event.preventDefault(); event.stopImmediatePropagation();
      return;
    }
    if (select.value !== planId) {
      event.preventDefault(); event.stopImmediatePropagation();
      choose(select, planId);
      requestAnimationFrame(() => requestAnimationFrame(() => button.isConnected && button.click()));
    }
  }, true);
  new MutationObserver(scheduleRefresh).observe(document.body, {childList: true, subtree: true});
  refresh();
})();
